import { RepairCostingFilterType } from '@/entities/repair-costing';
import { TRepairCostingSchema } from '@/schemas/repair-costing/repair-costing.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import {
  FindAllRepairServicesByEquipmentDamage,
  FindTotalCostingByVehiculeCheckId,
} from '../entities/repair-costing';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const REPAIR_COSTING_URI = '/repairCosting';

export const createNewRepairCosting = async (
  repairCosting: TRepairCostingSchema,
) => {
  return requestApi({
    url: REPAIR_COSTING_URI,
    method: HTTP_METHOD.POST,
    body: repairCosting,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingRepairCosting = async (
  query?: TRepairCostingSchema,
) => {
  let url = `${REPAIR_COSTING_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.equipmentId) {
    params.append('equipmentId', query.equipmentId);
  }

  if (query?.damageId) {
    params.append('damageId', query.damageId);
  }

  if (query?.repairServiceId) {
    params.append('repairServiceId', query.repairServiceId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllRepairCostings = async () => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/allRepairCostings`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const allRepairServicesByEquipmentDamage = async (
  query?: FindAllRepairServicesByEquipmentDamage,
) => {
  let url = `${REPAIR_COSTING_URI}/allRepairServicesByEquipmentDamage`;
  const params = new URLSearchParams();

  if (query?.equipmentId) {
    params.append('equipmentId', query.equipmentId);
  }

  if (query?.equipmentClassId) {
    params.append('equipmentClassId', query.equipmentClassId.toString());
  }

  if (query?.damageId) {
    params.append('damageId', query.damageId);
  }

  if (query?.damageClassId) {
    params.append('damageClassId', query.damageClassId.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const getAllRepairCostings = async (
  filter: RepairCostingFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const params = new URLSearchParams();

  params.append('filter', JSON.stringify(filter));
  params.append('page', String(page));
  params.append('limit', String(limit));
  params.append('sortBy', String(sortBy || ''));
  params.append('sortDirection', String(sortDirection || ''));

  return requestApi({
    url: `${REPAIR_COSTING_URI}/all?${params.toString()}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getRepairCostingById = async (id: string) => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalCostingByVehiculeCheckId = async (
  query?: FindTotalCostingByVehiculeCheckId,
) => {
  let url = `${REPAIR_COSTING_URI}/totalCostingByVehiculeCheckId`;
  const params = new URLSearchParams();

  if (query?.vehiculeCheckId) {
    params.append('vehiculeCheckId', query.vehiculeCheckId);
  }

  if (query?.reportType) {
    params.append('reportType', query.reportType);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const updateRepairCosting = async (
  repairCosting: TRepairCostingSchema,
) => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: repairCosting,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyRepairCostings = async (
  repairCostings: TRepairCostingSchema[],
) => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: repairCostings,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
